import { render, staticRenderFns } from "./RecoveryLinkSent.vue?vue&type=template&id=ab205e04&scoped=true"
import script from "./RecoveryLinkSent.vue?vue&type=script&lang=js"
export * from "./RecoveryLinkSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab205e04",
  null
  
)

export default component.exports